<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentReport /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentReport from '@/components/worker/dashboard/modules/report/ContentReport.vue'

export default 
{
  name: 'Report',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentReport
  }
}
</script>
<style>


</style>